import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { FlattenedQuestionHolder } from 'src/app/core-module/models/Audits/flattened-question-holder';
import { Question } from 'src/app/core-module/models/Audits/question';
import { SavedAuditsResult } from 'src/app/core-module/models/Audits/saved-audits-result';
import { AuditLocation } from 'src/app/core-module/models/Locations/audit-location';
import { UserLocationSave } from 'src/app/core-module/models/user-location-save';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { AuditGuidService } from 'src/app/core-module/services/audits/audit-guid.service';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { LocalStorageService } from 'src/app/core-module/services/local-storage.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';
import { SharedComponentsModule } from "src/app/shared-module/shared-components/shared-components.module";

@Component({
  selector: 'app-retrieve-audit',
  imports: [SharedComponentsModule],
  templateUrl: './retrieve-audit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './retrieve-audit.component.scss',
})
export class RetrieveAuditComponent {

  public AuditList: SavedAuditsResult = new SavedAuditsResult();
  public LocalAuditList: UserLocationSave[] = []
  public AwaitingServer: boolean = false;
  public MachineGUID: string = '';
  public pageLoading:boolean = true;

  constructor(private auditService: AuditService, private toastr: ToastrService, private localAudits: AuditService, public utilService: UtilService, private localStorage: LocalStorageService, private userService: AuthService, private router: Router) {
    this.refreshAuditInformation();
  }
  refreshAuditInformation(){
    this.fetchCentralAudits();
  }

  getMachineCode() {
    this.MachineGUID = '';
    this.localStorage.observables.localRef.find(e => { return e.ID == "deviceInfo" })?.Obs.pipe(tap((f: any) => { this.MachineGUID = f.MachineKey })).subscribe();
  }

  fetchCentralAudits() {
    this.auditService.fetchAuditRecoveryAudits().pipe(tap(res => {
      if (!res.IsError) {
        this.AuditList = res;
        this.pageLoading = false;
      } else {
         this.pageLoading = false;
        this.toastr.addToastr(new Toastr({ Message: "An error occurred, please try again later.", Type: 1 }))
      }
    })).subscribe();
  }

  addAuditToLocal(SaveID: number) {
    this.auditService.recoverAudit(SaveID).pipe(tap(res => {
      this.saveLocalAudit(res);
    })).subscribe()
  }
  saveLocalAudit(ULS: UserLocationSave) {
    ULS.LastUpdate = new Date();
    ULS.LastUpdateSet = true;
    var username = '';
    this.userService.getUserName()
      .pipe(
        tap((a: any) => {
          username = a.Username.toLowerCase();
        })
      )
      .subscribe();
    if (username == null) {
      return;
    }
    var localData: any;
    this.auditService.getALLLocalAudits()
      .pipe(
        tap((a: UserLocationSave[]) => {
          localData = a;
        })
      )
      .subscribe();
    if (localData == null) {

      var saveList: UserLocationSave[] = [];
      saveList.push(ULS);
      this.localStorage.setData(2, saveList);

    } else {
      var parsedData: UserLocationSave[] = <UserLocationSave[]>localData;
      var currentSet: UserLocationSave = new UserLocationSave();
      var localDataIndex = parsedData.findIndex((e) => {
        return e.Username.toLowerCase() == username.toLowerCase() && e.AuditGUID == ULS.AuditGUID;
        //return e.Username == username && e.Location.LocationID == this.location.LocationID && e.FlattenedQuestions[0].AuditID == this.currentData.AuditID;
      });
      if (localDataIndex != -1) {
        currentSet = parsedData.find((f) => {
          return f.Username.toLowerCase() == username.toLowerCase() && f.AuditGUID == ULS.AuditGUID;
          //return f.Username == username && f.Location.LocationID == this.location.LocationID && f.FlattenedQuestions[0].AuditID == this.currentData.AuditID;
        })!;
        if (currentSet.FlattenedQuestions.some((g) => { return g.AuditID == ULS.FlattenedQuestions[0].AuditID; })) {
          var tempQuestions: Question[] = [];
          ULS.FlattenedQuestions[0].Questions.forEach(e => {
            tempQuestions.push(new Question(e));
          })
          currentSet.FlattenedQuestions.find((h) => {
            return h.AuditID == ULS.FlattenedQuestions[0].AuditID;
          })!.Questions = tempQuestions;
          currentSet.LastUpdate = new Date();
          currentSet.LastUpdateSet = true;
        } else {
          currentSet = ULS;
          parsedData.push(currentSet);
        }
      } else {
        parsedData.push(ULS);
      }
      this.localStorage.setData(2, parsedData);
    }
    this.jumpToAudit(ULS.FlattenedQuestions[0], ULS.Location, ULS.AuditGUID);
  }
  jumpToAudit(savedAudit: FlattenedQuestionHolder, location: AuditLocation, auditGUID: string) {
    this.router.navigateByUrl('audit', { state: { "SavedAudit": savedAudit, "SavedLocation": location, "AuditGUID": auditGUID } });
  }


  hasLocalDateSet(auditGUID: string): boolean {
    return this.LocalAuditList.find(e => e.AuditGUID == auditGUID)!.LastUpdateSet;
  }
  getLocalDate(auditGUID: string): string {
    return this.utilService.humanDateTime(this.LocalAuditList.find(e => e.AuditGUID == auditGUID)!.LastUpdate);
  }
}
